import React from 'react';
import { BatchesPaidContainer } from '../../../containers';

export const BatchesPaid = () => <BatchesPaidContainer />;
